// Subtle notification sound — two short sine blips via WebAudio.
// Safe to call often; auto-fallbacks if WebAudio blocked (e.g., no user gesture yet).
let _ctx = null;

function getCtx() {
  if (typeof window === 'undefined') return null;
  if (_ctx) return _ctx;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  try { _ctx = new AC(); } catch { return null; }
  return _ctx;
}

export function playNotificationSound({ volume = 0.08 } = {}) {
  try {
    // Respect user mute preference.
    if (typeof window !== 'undefined' && window.localStorage?.getItem('zv-notify-muted') === '1') return;
    const ctx = getCtx();
    if (!ctx) return;
    if (ctx.state === 'suspended') {
      ctx.resume().catch(() => {});
    }
    const now = ctx.currentTime;
    const playBlip = (freq, start, dur) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, start);
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(volume, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + dur);
      osc.connect(gain); gain.connect(ctx.destination);
      osc.start(start); osc.stop(start + dur + 0.02);
    };
    playBlip(880, now, 0.12);
    playBlip(1320, now + 0.08, 0.14);
  } catch { /* ignore */ }
}

export function setNotificationMuted(muted) {
  try {
    if (muted) window.localStorage.setItem('zv-notify-muted', '1');
    else window.localStorage.removeItem('zv-notify-muted');
  } catch { /* ignore */ }
}

export function isNotificationMuted() {
  try { return window.localStorage.getItem('zv-notify-muted') === '1'; } catch { return false; }
}
